// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const SurvivorConsentLogs = t.struct({
    contactId: t.Number,
    firstName: t.String,
    middleName: t.String,
    lastName: t.String,
    communicationTypeId: t.String,
    communicationValue: t.String,
    survivorStatus: t.String,
    remark: t.String,
    modifiedBy: t.String,
    timeStamp: t.String
}, {
    defaultProps: {
        contactId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        communicationTypeId: '',
        communicationValue: '',
        survivorStatus: '',
        remark: '',
        modifiedBy: '',
        timeStamp: ''
    },
    name: 'SurvivorConsentLogs',
    strict: true
});
